import React, {useEffect} from "react";
import { Link } from "react-router-dom";
// import SponcerBanner from '../components/sponcerbanner';
import Text from "../components/text";
import { Helmet } from "react-helmet-async";
function WhatsNew() {
  const { WhatsNew: text } = Text;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Hero div */}

      <Helmet>
        <title>{Text.WhatsNew.Hero.Title} | CollegeRank</title>
        <meta name="description" content={Text.WhatsNew.Hero.Description} />
      </Helmet>
      <div className="bg-gradient-to-r from-blue-600 to-blue-800 py-16 px-4">
        <div className="container mx-auto text-center max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {text.Hero.Title}
          </h1>
          <p className="text-xl text-blue-100 mb-8">{text.Hero.Description}</p>
          <Link
            to="/"
            className="inline-block bg-white text-blue-700 hover:bg-blue-50 font-medium px-6 py-3 rounded-lg shadow-md transition-colors"
          >
            {text.Hero.ButtonText}
          </Link>
        </div>
      </div>
      {/* Main Content */}
      <div className="container mx-auto px-4 py-12 max-w-5xl">
        {/* Primary New Feature */}
        <div className="mb-8">
          <div className="flex items-center mb-6">
            <div className="bg-blue-100 p-3 rounded-full mr-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-8 w-8 text-blue-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                />
              </svg>
            </div>
            <h2 className="text-3xl font-bold text-gray-800">
              {text.SafetyMargin.Title}
            </h2>
          </div>

          <div className="bg-white rounded-xl shadow-sm p-8 border border-gray-200 mb-8">
            <p className="text-gray-700 leading-relaxed mb-6">
              {text.SafetyMargin.Description}
            </p>

            <div className="bg-blue-50 rounded-lg p-6 mb-6 border-l-4 border-blue-500">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                {text.SafetyMargin.WhyMatters.Title}
              </h3>
              <p className="text-gray-700">
                {text.SafetyMargin.WhyMatters.Description}
              </p>
            </div>

            <h3 className="text-xl font-semibold text-gray-800 mb-4">
              {text.SafetyMargin.HowItWorks.Title}
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <div className="bg-gradient-to-b from-green-50 to-green-100 rounded-lg p-5 border border-green-200">
                <div className="w-10 h-10 bg-green-400 rounded-full flex items-center justify-center mb-3">
                  <span className="text-white font-bold">1</span>
                </div>
                <h4 className="text-lg font-semibold text-gray-800 mb-2">
                  {text.SafetyMargin.HowItWorks.Safe.Title}
                </h4>
                <p className="text-gray-700">
                  Colleges where the closing ranks are higher than your rank.
                  These colleges offer a{" "}
                  <span className="font-medium text-green-700">
                    high chance of admission
                  </span>
                  .
                </p>
              </div>

              <div className="bg-gradient-to-b from-yellow-50 to-yellow-100 rounded-lg p-5 border border-yellow-200">
                <div className="w-10 h-10 bg-yellow-400 rounded-full flex items-center justify-center mb-3">
                  <span className="text-white font-bold">2</span>
                </div>
                <h4 className="text-lg font-semibold text-gray-800 mb-2">
                  {text.SafetyMargin.HowItWorks.Moderate.Title}
                </h4>
                <p className="text-gray-700">
                  Colleges where the closing ranks are slightly below your rank.
                  Admission here is{" "}
                  <span className="font-medium text-yellow-700">
                    possible but not guaranteed
                  </span>
                  .
                </p>
              </div>

              <div className="bg-gradient-to-b from-red-50 to-red-100 rounded-lg p-5 border border-red-200">
                <div className="w-10 h-10 bg-red-400 rounded-full flex items-center justify-center mb-3">
                  <span className="text-white font-bold">3</span>
                </div>
                <h4 className="text-lg font-semibold text-gray-800 mb-2">
                  {text.SafetyMargin.HowItWorks.Ambitious.Title}
                </h4>
                <p className="text-gray-700">
                  Colleges where the closing ranks are significantly below your
                  rank. These are{" "}
                  <span className="font-medium text-red-700">
                    more challenging
                  </span>{" "}
                  but still possible.
                </p>
              </div>
            </div>

            <h3 className="text-xl font-semibold text-gray-800 mb-4">
              {text.SafetyMargin.Example.Title}
            </h3>

            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden mb-6">
              <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
                <p className="font-medium text-gray-700">
                  {text.SafetyMargin.Example.Intro}
                </p>
              </div>
              <div className="p-6">
                <ul className="space-y-4">
                  <li className="flex items-start">
                    <span className="w-5 h-5 bg-green-400 rounded-full mt-1 mr-3 flex-shrink-0"></span>
                    <span>{text.SafetyMargin.Example.Safe}</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-5 h-5 bg-yellow-400 rounded-full mt-1 mr-3 flex-shrink-0"></span>
                    <span>{text.SafetyMargin.Example.Moderate}</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-5 h-5 bg-red-400 rounded-full mt-1 mr-3 flex-shrink-0"></span>
                    <span>{text.SafetyMargin.Example.Ambitious}</span>
                  </li>
                </ul>
              </div>
            </div>

            <h3 className="text-xl font-semibold text-gray-800 mb-4">
              {text.SafetyMargin.HowToUse.Title}
            </h3>
            <ol className="list-decimal pl-6 space-y-3 mb-6">
              <li className="text-gray-700">
                {text.SafetyMargin.HowToUse.Step1}
              </li>
              <li className="text-gray-700">
                {text.SafetyMargin.HowToUse.Step2}
              </li>
              <li className="text-gray-700">
                {text.SafetyMargin.HowToUse.Step3}
              </li>
              <li className="text-gray-700">
                {text.SafetyMargin.HowToUse.Step4}
              </li>
            </ol>
          </div>
        </div>

        {/* <SponcerBanner className="my-8" /> */}

        {/* Other Updates */}
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-8">
            {text.OtherImprovements.Title}
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200">
              <div className="p-6">
                <div className="bg-purple-100 text-purple-600 w-12 h-12 rounded-full flex items-center justify-center mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {text.OtherImprovements.Security.Title}
                </h3>
                <p className="text-gray-600">
                  {text.OtherImprovements.Security.Description}
                </p>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200">
              <div className="p-6">
                <div className="bg-indigo-100 text-indigo-600 w-12 h-12 rounded-full flex items-center justify-center mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {text.OtherImprovements.Authentication.Title}
                </h3>
                <p className="text-gray-600">
                  {text.OtherImprovements.Authentication.Description}
                </p>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200">
              <div className="p-6">
                <div className="bg-blue-100 text-blue-600 w-12 h-12 rounded-full flex items-center justify-center mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {text.OtherImprovements.Mobile.Title}
                </h3>
                <p className="text-gray-600">
                  {text.OtherImprovements.Mobile.Description}
                </p>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200">
              <div className="p-6">
                <div className="bg-orange-100 text-orange-600 w-12 h-12 rounded-full flex items-center justify-center mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {text.OtherImprovements.TSEAMCET.Title}
                </h3>
                <p className="text-gray-600">
                  {text.OtherImprovements.TSEAMCET.Description}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Coming Soon */}
        <div>
          <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-xl shadow-lg overflow-hidden">
            <div className="px-6 py-12 md:px-12 text-center">
              <h2 className="text-3xl font-bold text-white mb-4">
                {text.ComingSoon.Title}
              </h2>
              <p className="text-blue-100 mb-8 max-w-2xl mx-auto">
                {text.ComingSoon.Description}
              </p>
              <Link
                to="/"
                className="inline-block bg-white text-blue-700 hover:bg-blue-50 font-medium px-6 py-3 rounded-lg shadow-md transition-colors"
              >
                {text.ComingSoon.ButtonText}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhatsNew;
